import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function ratingMobileWidget() {
  return new SelectRefinementWidget({
    selectType: "single",
    connector: instantsearch.connectors.connectRatingMenu
  }).widget({
    attribute: "rounded_rating",
    container: "rating_mobile",
    max: 6,
    items: [
      { label: "1+", value: 1 },
      { label: "2+", value: 2 },
      { label: "3+", value: 3 },
      { label: "4+", value: 4 },
      { label: "5", value: 5 }
    ]
  })
}

export function ratingWidget({ showCounters }) {
  return new DistinctRefinementWidget({
    connector: instantsearch.connectors.connectRatingMenu,
    showCounters: showCounters,
    facetCounterAttribute: "rounded_rating",
    facetCounterComparisonFn: (hitValue, facetValue) => {
      return hitValue >= facetValue
    }
  }).widget({
    type: 'rating',
    container: 'rating',
    attribute: 'rounded_rating',
    max: 6,
    templates: {
      item: (item) => {
        return loadTemplate(showCounters ? "cle_rating_filter_template_with_counters" : "cle_rating_filter_template").interpolateObject({
          checked: item.isRefined ? "checked" : "",
          value: item.value,
          description: item.value < 5 ? `${item.value}+` : item.value,
          count: item.count,
          stars: loadTemplate(`cle_rating_filter_template_${item.value}_stars`)
        })
      }
    }
  })
}
